<template>
  <div :style="styles.base" @click="handleClickEvent()" @mouseenter="handleEvent('hover')">
    <!--  begin 默认配置tab -->

    <div
      class="c-tabs"
      v-if="tab === 1"
      :style="{...styles.base,left:0,top:0, backgroundImage: `url(${backgroundImageDefault})`}"
    >
      <div
        :class="{
        'c-tabs__header': true,
        'tabs-is-top': configurationData.placement === 'top',
        'tabs-is-left': configurationData.placement === 'left',
        'tabs-is-right': configurationData.placement === 'right',
        'tabs-is-bottom': configurationData.placement === 'bottom',
      }"
        :style="headerStyle"
      >
        <div class="c-tabs__nav-wrap">
          <template v-for=" (tab, index) in configurationData.list">
            <div
              :key="index"
              class="c-tabs__nav-item"
              @click="pickTabDefault(index)"
              :class="{ active: index === activeIndex}"
              :style="tabItemStyleDefault"
            >{{tab.text}}</div>
          </template>
        </div>
      </div>
      <div class="c-tabs__content">
        <template v-for=" (tab, index) in configurationData.list">
          <div :key="index" class="c-tabs__content-slot" v-show="index === activeIndex">
            <slot :name="`${index}`"></slot>
          </div>
        </template>
      </div>
    </div>
    <!-- end 默认配置tab -->

    <!-- begin  分离配置tab  -->
    <div
      class="c1-tabs-separate"
      v-if="tab === 2 "
      :style="{...styles.base,left:0,top:0,'--head-tab-gray':headGay}"
    >
      <!--   点击头部  区域-->
      <div
        :class="{
          'c1-tabs-separate-area' :true,
          'tabs-separate-is-top': configurationData.placement === 'top',
          'tabs-separate-is-left': configurationData.placement === 'left',
          'tabs-separate-is-right': configurationData.placement === 'right',
          'tabs-separate-is-bottom': configurationData.placement === 'bottom',
        }"
        :style="{width:styles.base.width,height:styles.base.height}"
      >
        <div :class="{
        'c1-tabs-separate__header': true,
      }" :style="headerStyle">
          <!--   点击头部  tab 切换按钮-->
          <div class="c1-tabs-separate__nav-wrap" :style="tabItemStyle">
            <template v-for=" (tab, index) in separateTabImgList">
              <div
                :key="index"
                class="c1-tabs-separate__nav-item"
                @click="pickTab(index)"
                :class="{ active: index === activeIndex}"
                :style="tabItemClickStyle"
              ></div>
            </template>
          </div>
          <!--   点击头部  tab 切换按钮-->
        </div>
        <!--   点击头部  区域-->
        <div
          :class="{
        'c1-tabs-separate__content':true,
        'tabs-separate---is-top': configurationData.placement === 'top',
        'tabs-separate---is-left': configurationData.placement === 'left',
        'tabs-separate---is-right': configurationData.placement === 'right',
        'tabs-separate---is-bottom': configurationData.placement === 'bottom',
        }"
          :style="trackStyle"
        >
          <template v-for=" (tab, index) in separateTabImgList">
            <div
              :key="index"
              class="c1-tabs-separate__content-area"
              :style="{backgroundImage: `url(${tab.backgroundImage})`,...mainImgSize}"
            ></div>
          </template>
        </div>
        <!--begin  其他内嵌组件  -->
        <div
          :style="{...trackStyle}"
          :class="{
        'c1-tabs-separate__content-slot-group':true,
        'tabs-separate__content---is-top': configurationData.placement === 'top',
        'tabs-separate__content---is-left': configurationData.placement === 'left',
        'tabs-separate__content---is-right': configurationData.placement === 'right',
        'tabs-separate__content---is-bottom': configurationData.placement === 'bottom',
        }"
        >
          <template v-for=" (tab, index) in separateTabImgList">
            <div
              :key="index"
              :class="{
              'c1-tabs-separate__content-slot':true,
            }"
              :style="{width:mainImgSize.width,height:mainImgSize.height}"
            >
              <slot :name="`${index}`"></slot>
            </div>
          </template>
        </div>
        <!-- end  其他内嵌组件  -->
      </div>
    </div>
    <!-- end  分离配置tab  -->
  </div>
</template>

<script >
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CTabs',
  mixins: [componentBaseMixin],
  props: {},
  data() {
    return {
      activeIndex: 0, // 当前激活的选项卡下标

      // 整体配置data
      tab: 1,
      activeIndexDefault: 0, // 当前激活的选项卡下标
      backgroundImageDefault: '',

      // 分离配置data
      backgroundImage: '',
      trackStyle: {},
      tabItemStyle: {},
    };
  },
  computed: {
    headerStyle() {
      const { placement } = this.configurationData;
      if (placement === 'left' || placement === 'right') {
        return {
          width: this.styles.header?.val || '5%',
          height: '100%',
        };
      }
      return {
        width: '100%',
        height: this.styles.header?.val || '5%',
      };
    },
    tabItemStyleDefault() {
      return {
        border: this.$isInEditor && !this.isInPreview ? '1px dashed' : 0,
      };
    },

    separateTabImgList() {
      return this.configurationData.list || [];
    },
    multiplier() {
      let baseWidth = 750;
      if (this.deviceMode === 'h5-h') {
        baseWidth = 1334;
      }
      return 100 * (window.screen.width / baseWidth);
    },
    tabItemClickStyle() {
      return {
        border: this.$isInEditor && !this.isInPreview ? '1px dashed' : 0,
      };
    },
    mainImgSizePure() {
      let gay = this.styles.header?.val || '0.65rem';
      const width = this.tranRemToPx(this.styles.base.width);
      const height = this.tranRemToPx(this.styles.base.height);
      const { placement } = this.configurationData;
      gay = this.tranRemToPx(gay);
      if (placement === 'top' || placement === 'bottom') {
        return { width, height: height - gay };
      }
      return { width: width - gay, height };
    },
    mainImgSize() {
      const { width, height } = this.mainImgSizePure;
      return { width: `${width}px`, height: `${height}px` };
    },
    headGay() {
      const gay = this.styles.header?.val || '0.65rem';
      return `${this.tranRemToPx(gay)}px`;
    },
  },
  watch: {
    // 响应编辑器注入的slot切换
    'configurationData.tabConfigType': {
      handler(value) {
        if (value) {
          this.tab = value === 'CTabsDefault' ? 1 : 2;
          this.initFunc();
        }
      },
      immediate: true,
    },
    'configurationData.list': {
      handler(value) {
        if (value) {
          if (this.tab === 2) {
            this.pickTab(this.activeIndex);
          }
        }
      },
      immediate: true,
    },
    curSlot: {
      deep: true,
      handler(curSlot) {
        console.log('watch curSlot 2 in CTab component', curSlot, curSlot[this.uid]);
        const index = parseInt(curSlot[this.uid], 10);
        if (isNaN(index)) {
          return false;
        }
        if (this.tab === 1) {
          this.activeIndex = index;
          this.backgroundImageDefault = this.configurationData.list[this.activeIndex]?.backgroundImage || '';
        } else {
          console.log('tabs AA function  curSlot ');

          this.pickTab(index);
        }
      },
    },
  },
  mounted() {
    console.log('tabs  default configurationData', this.configurationData);
    this.tab = (this.configurationData.tabConfigType || 'CTabsDefault') === 'CTabsDefault' ? 1 : 2;
    this.initFunc();
  },

  methods: {
    initFunc() {
      console.log('tabs  initFunc');
      if (this.tab === 1) {
        this.pickTabDefault(0);
      } else {
        this.pickTab(0);
        this.$nextTick(() => {
          this.initOnLoadImage();
        });
      }
    },

    // 默认tab处理
    pickTabDefault(index) {
      this.activeIndex = index;
      this.backgroundImageDefault = this.configurationData.list[index]?.backgroundImage || '';
      // 上报tab切换
      !this.$isInEditor
        && this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'switch_tab',
          eventData: {
            tab_id: index,
          },
        });
    },
    // 分离配置tab处理
    pickTab(index) {
      console.log('index', index);
      this.activeIndex = index;
      if (index === 0) {
        this.trackStyle = {};
      }
      const tabImgUrl = this.separateTabImgList[index]?.tabImg;
      this.tabItemStyle = {
        backgroundColor: 'transparent',
        backgroundImage: `url('${tabImgUrl}')`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      };
      const { placement } = this.configurationData;
      const isTopAndBottom = placement === 'top' || placement === 'bottom';

      this.trackStyle = {
        transition: 'transform 400ms ease',
        transform: isTopAndBottom
          ? `translateX(-${index * this.mainImgSizePure.width}px)`
          : `translateY(-${index * this.mainImgSizePure.height}px)`,
      };
      // // 上报tab切换
      !this.$isInEditor
        && this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'switch_tab',
          eventData: {
            tab_id: index,
          },
        });
    },
    // 图片自动加载解决 tab点击切换的时候 因为没有加载的 图片一闪动作
    initOnLoadImage() {
      const { separateTabImgList = [] } = this.configurationData;
      const imageList = separateTabImgList.filter(item => item.tabImg).map(item => item.tabImg);
      const images = [];
      imageList.forEach((backgroundImage, index) => {
        images[index] = new Image();
        images[index].src = backgroundImage;
      });
    },
    // rem 转 px的时候 实际乘数

    tranRemToPx(unit) {
      // eslint-disable-next-line no-param-reassign
      unit = unit.toLowerCase();
      if (unit.indexOf('rem') > -1) {
        const value = parseFloat(unit.substring(0, unit.length - 3), 3);
        return value * this.multiplier;
      }
      if (unit.indexOf('px') > -1) {
        return parseFloat(unit.substring(0, unit.length - 2), 3);
      }
    },
  },
};
</script>

<style lang="scss">
.c-tabs {
  overflow: hidden;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;

  .c-tabs__header.tabs-is-top {
    left: 0;
    top: 0;

    .c-tabs__nav-wrap {
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }

  .c-tabs__header.tabs-is-bottom {
    left: 0;
    bottom: 0;

    .c-tabs__nav-wrap {
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }

  .c-tabs__header.tabs-is-left {
    left: 0;
    top: 0;

    .c-tabs__nav-wrap {
      flex-direction: column;
    }
  }

  .c-tabs__header.tabs-is-right {
    right: 0;
    top: 0;

    .c-tabs__nav-wrap {
      flex-direction: column;
    }
  }

  .c-tabs__header {
    position: absolute;
    overflow: hidden;
    user-select: none;

    .c-tabs__nav-wrap {
      display: flex;
      font-size: 0;
      width: 100%;
      height: 100%;

      .c-tabs__nav-item {
        flex: 1;
        height: 100%;
        display: block;
        text-align: center;
        vertical-align: middle;
        font-size: 0.2rem;
      }
    }
  }

  .c-tabs__content {
    overflow: hidden;
    height: 100%;
  }
}

//分离配置tab
.c1-tabs-separate {
  overflow: hidden;
  //background-color: red;
  .c1-tabs-separate-area {
    display: flex;
    flex: 1 0 auto;
  }

  .c1-tabs-separate-area.tabs-separate-is-top {
    flex-direction: column;
    flex-wrap: wrap;
  }

  .c1-tabs-separate-area.tabs-separate-is-left {
    flex-direction: column;
    flex-wrap: wrap;
  }

  .c1-tabs-separate-area.tabs-separate-is-bottom {
    flex-direction: column-reverse;
    flex-wrap: wrap;
  }

  .c1-tabs-separate-area.tabs-separate-is-right {
    flex-direction: row-reverse;
    flex-wrap: nowrap;
  }

  .tabs-separate-is-left .c1-tabs-separate__nav-wrap {
    flex-direction: column;
    flex-wrap: wrap;
  }

  .tabs-separate-is-right .c1-tabs-separate__nav-wrap {
    flex-direction: column;
    flex-wrap: wrap;
  }

  .c1-tabs-separate__header {
    overflow: hidden;
    position: absolute;
    z-index: 3;

    .c1-tabs-separate__nav-wrap {
      display: flex;
      font-size: 0;
      width: 100%;
      height: 100%;

      .c1-tabs-separate__nav-item {
        flex: 1;
        flex-shrink: 0;
        text-align: center;
        vertical-align: middle;
        height: 100%;
        display: block;
      }
    }
  }

  .c1-tabs-separate__content {
    display: flex;
    flex-shrink: 0;
    position: absolute;
  }

  .c1-tabs-separate__content-area {
    height: 100%;
    width: 100%;
    flex-shrink: 0;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .c1-tabs-separate__content-slot {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .c1-tabs-separate__content-slot-group {
    display: flex;
    position: absolute;
    flex-shrink: 0;
    z-index: 1;
  }

  .tabs-separate---is-top {
    flex-direction: row;
    flex-wrap: nowrap;
    top: var(--head-tab-gray);
  }

  .tabs-separate---is-left {
    flex-direction: column;
    flex-wrap: wrap;
    left: var(--head-tab-gray);
  }

  .tabs-separate---is-bottom {
    flex-direction: row;
    flex-wrap: nowrap;
    bottom: var(--head-tab-gray);
  }

  .tabs-separate---is-right {
    flex-direction: column;
    flex-wrap: nowrap;
    right: var(--head-tab-gray);
  }

  .tabs-separate__content---is-top {
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .tabs-separate__content---is-left {
    flex-direction: column;
    flex-wrap: wrap;
  }

  .tabs-separate__content---is-bottom {
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .tabs-separate__content---is-right {
    flex-direction: column;
    flex-wrap: nowrap;
  }
}
</style>
